
    import './styles.scoped.css';
    export default {
  "content": "awsui_content_vjswe_wxrmh_66",
  "button": "awsui_button_vjswe_wxrmh_70",
  "variant-normal": "awsui_variant-normal_vjswe_wxrmh_132",
  "disabled": "awsui_disabled_vjswe_wxrmh_150",
  "variant-primary": "awsui_variant-primary_vjswe_wxrmh_157",
  "variant-link": "awsui_variant-link_vjswe_wxrmh_182",
  "variant-icon": "awsui_variant-icon_vjswe_wxrmh_207",
  "variant-control-group-action": "awsui_variant-control-group-action_vjswe_wxrmh_232",
  "variant-inline-icon": "awsui_variant-inline-icon_vjswe_wxrmh_259",
  "variant-inline-icon-pointer-target": "awsui_variant-inline-icon-pointer-target_vjswe_wxrmh_284",
  "variant-inline-link": "awsui_variant-inline-link_vjswe_wxrmh_309",
  "variant-modal-dismiss": "awsui_variant-modal-dismiss_vjswe_wxrmh_338",
  "variant-flashbar-icon": "awsui_variant-flashbar-icon_vjswe_wxrmh_363",
  "variant-breadcrumb-group": "awsui_variant-breadcrumb-group_vjswe_wxrmh_388",
  "variant-menu-trigger": "awsui_variant-menu-trigger_vjswe_wxrmh_418",
  "button-no-text": "awsui_button-no-text_vjswe_wxrmh_537",
  "button-no-wrap": "awsui_button-no-wrap_vjswe_wxrmh_541",
  "full-width": "awsui_full-width_vjswe_wxrmh_544",
  "button-compact": "awsui_button-compact_vjswe_wxrmh_561",
  "icon-left": "awsui_icon-left_vjswe_wxrmh_584",
  "icon-right": "awsui_icon-right_vjswe_wxrmh_589",
  "icon": "awsui_icon_vjswe_wxrmh_584",
  "link": "awsui_link_vjswe_wxrmh_608",
  "disabled-with-reason": "awsui_disabled-with-reason_vjswe_wxrmh_608"
};
  